import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { WithdrawalcoinPage } from '../withdrawalcoin/withdrawalcoin';

// import * as $ from "jquery";

/**
 * Generated class for the WithdrawalcoinlistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-withdrawalcoinlist',
  templateUrl: 'withdrawalcoinlist.html',
})
export class WithdrawalcoinlistPage {

    list: string = 'completed';
    segment: string;
    target_coin: string;

	loginId: string;
	email: string;
    api_key: string;
    version: string;
	wallet_address: string;
    coin: string = '';
    office_address: string;
	address: string;
	rate: any = [];

	completed_list: any = [];
	pending_list: any = [];
    // params: any[] = [];
    // count: number = 0;
    // max_length: number = 0;
    
	coin_unit: string;
	token_unit: string;
	unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;
    
    balance: any = [];
    // balance_usdt: string;

	imagePath: string;
	qrData = null;
  	createdCode = null;
	scannedCode = null;

	texts: any = [];
    language : string;

    isButton : boolean = true;
    isToken : boolean = false;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
        let segment = navParams.get("segment");
        if (segment == 'pending') {
            this.list = segment;
        } else {
            this.list = 'completed';
        }

        // this.coin_unit = navParams.get("target_coin");
        this.target_coin = navParams.get("target_coin");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcoinlist");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.token_unit = localStorage.getItem("token_unit");
		this.unit = localStorage.getItem("unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

        if (this.target_coin == 'token') {
            this.isToken = true; 
            this.coin_unit = this.token_unit;
        }

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).withdrawalcoinlist;
	}

    _cancel(idx){
		let alert = this.alertCtrl.create({
			message: this.texts.alertM_cancel,
			buttons: [
				{
					text: this.texts.no_btn
				},
				{
					text: this.texts.yes_btn,
					handler: () => {
                        let url
                        if (this.isToken) {
                            url = "withdraw/binance/usdt/delete";
                        } else {
                            url = "withdraw/binance/index/delete";
                        }
						let body = JSON.stringify({
                            api: this.api_key,
                            language: this.language,
                            version: this.version,
							idx: idx
						});
						this.http.post(url, body).then((res: any) => {
							if(res.result === "OK"){
                                this._init();

							} else if(res.result ==="RELOAD"){
								let alert = this.alertCtrl.create({
									message: res.message,
									buttons: ['OK']
								});
								alert.present();
								this._init();

							} else {
								let alert = this.alertCtrl.create({
									message: res.message,
									buttons: ['OK']
								});
								alert.present();
							}
						},(err)=>{	
							//// HTTP 에러인 경우
							let alert = this.alertCtrl.create({
								message: err,
								buttons: ['OK']
							});
							alert.present();
						
						});
					}
				}
			]
		});
		alert.present();
    }

	_init() {		
		this.completed_list = [];
		this.pending_list = [];
		
        let url
        if (this.isToken) {
            url = "withdraw/binance/usdt/list";
        } else {
            url = "withdraw/binance/index/list";
        }
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){

                this.balance = res.balance;
                // this.balance_usdt = res.balance.usdt;
                if(res.list != undefined) {
                    let list: any;

                    let address: string;
                    let address_left: string;
                    let address_right: string;
                    let address_left_obj: any;
                    let address_right_obj: any;

                    let txid: string;
                    let txid_left: string;
                    let txid_right: string;
                    let txid_left_obj: any;
                    let txid_right_obj: any;

                    if(res.list.completed != undefined) {
                        let completed_list = res.list.completed;
                        let completed_list_length = res.list.completed.length;
                    
                        for (let i = 0; i < completed_list_length; i++) {
                            list = completed_list[i];
                    
                            address = completed_list[i].address;                            
                            address_left = address.substr(0, 5);
                            address_right = address.substr(-4, 4);                            
                            address_left_obj = {address_left : address_left};
                            address_right_obj = {address_right : address_right};
                    
                            txid = completed_list[i].txid;                            
                            txid_left = txid.substr(0, 5);
                            txid_right = txid.substr(-4, 4);
                            txid_left_obj = {txid_left : txid_left};
                            txid_right_obj = {txid_right : txid_right};
                                                
                            completed_list[i] = Object.assign(list, address_left_obj, address_right_obj, txid_left_obj, txid_right_obj);
                        }
                        this.completed_list = completed_list;
                    
                    }
                    if(res.list.pending != undefined) {
                        let pending_list = res.list.pending;
                        let pending_list_length = res.list.pending.length;
                    
                        for (let i = 0; i < pending_list_length; i++) {
                            list = pending_list[i];
                    
                            address = pending_list[i].address;                            
                            address_left = address.substr(0, 5);
                            address_right = address.substr(-4, 4);                            
                            address_left_obj = {address_left : address_left};
                            address_right_obj = {address_right : address_right};
                                                
                            pending_list[i] = Object.assign(list, address_left_obj, address_right_obj);
                        }
                        this.pending_list = pending_list;
                    
                        console.log(this.pending_list);
                    }
                }
				
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: err.message,
				buttons: ['OK']
			});
			alert.present();
		});
	}

	// _doInfinite(infiniteScroll) {
    //     setTimeout(() => {    
    //         for (var i = 0; i < 9; i++) {
    //             if(this.max_length <= this.count) break;
    //             this.params.push(this.items[this.count]);                
    //             this.count++;
    //         } 

    //         infiniteScroll.complete();
    //     }, 500);
	// }

	_copy(event) {
		this.clipboard.copy(event);
		let alert = this.alertCtrl.create({
        title: "Copy",
        message: event, 
		buttons: ['OK']
		});
		alert.present();
	}

    _withdrawal() {
        // let alert = this.alertCtrl.create({
        //     message: this.texts.alertM_ready,
        //     buttons: ['OK']
        // });
        // alert.present();

        this.navCtrl.push(WithdrawalcoinPage, {target_coin : this.target_coin});
    }
}



// WEBPACK FOOTER //
// ./src/pages/withdrawalcoinlist/withdrawalcoinlist.ts